var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-badge",class:[
    ("type-" + (_vm.badge.type))
  ]},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"counter"},[_vm._v(_vm._s(_vm.badge.count))]),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t(_vm.badge.label)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }